module.exports = __webpack_public_path__ + "static/media/loom.3e8eff9a.png";